/*
 * @Description  : 文库检索页
 * @Author       : 王帅
 * @Date         : 2024-09-25 16:33:41
 * @LastEditors  : zhanglei
 * @LastEditTime : 2025-07-04 14:20:05
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\library-server\index.js
 */
import request from '../../request.js'

// 文库-分类查询  --- 刘志争
export const zcClassifyPage = function(data) {
	return request({
		url: '/docManage/zcClassifyPage',
		method: 'post',
		data
	})
}

// 文库-保存浏览次数、下载记录  --- 叶凡
export const saveRead = function(data) {
	return request({
		url: '/libRead/saveRead',
		method: 'post',
		data
	})
}

// 文库-首页加载  --- 叶凡
export const zcHomePage = function(data) {
	return request({
		url: '/docManage/zcHomePage',
		method: 'post',
		data
	})
}

// 文库-文库查看  --- 刘志争
export const documentFile = function(data) {
	return request({
		url: '/docManage/documentFile',
		method: 'post',
		data
	})
}

// 文库-一级检索页查询  --- 刘志争
export const rootIndex = function(data) {
	return request({
		url: '/docType/rootIndex',
		method: 'post',
		data
	})
}

// 文库-一级检索页查询  --- 刘志争
export const getZjkDictsBySysCode = function(data) {
	return request({
		url: '/ngsExtenal/getZjkDictsBySysCode',
		method: 'post',
		data
	})
}
